import React from 'react';
import PropTypes from 'prop-types';
import QueueDialog from '../queue/QueueDialog';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import OverlayController from '../overlay/OverlayController';
import Queue from '../queue/Queue';
import queries from '../../graphql/queries';
import { compose } from 'react-apollo';
import { GraphQLStackTrace } from '../../utils/utils'
import {Direction, withReorder} from "../withReorder/WithReorder";
import mutations from "../../graphql/mutations";
import _ from 'lodash';
import './Board.css'


export default compose(
    queries.projectQueryHocWithName('projectData'),
    queries.boardQueryHocWithName('boardData'),
    mutations.updateQueuesOrderMutationHoc,
    withReorder({direction: Direction.Horizontal, itemSize: 320})
)(class extends React.Component {

    static propTypes = {
        params: PropTypes.shape({
            projectId: PropTypes.string.isRequired,
            boardId: PropTypes.string.isRequired
        }).isRequired,
        projectData: PropTypes.object.isRequired,
        boardData: PropTypes.object.isRequired,
        updateQueuesOrder: PropTypes.func.isRequired,

        beginReorder: PropTypes.func.isRequired,
        resetReorder: PropTypes.func.isRequired,
        onMouseDown: PropTypes.func.isRequired,
        indexOfItem: PropTypes.func.isRequired,
        reordering: PropTypes.bool.isRequired,
        reorderItems: PropTypes.array,
        draggedItem: PropTypes.any,
        translateX: PropTypes.number,
        translateY: PropTypes.number
    };

    static defaultProps = {

    };

    constructor(props) {
        super(props);

        let projectId = this.props.params.projectId;
        let boardId = this.props.params.boardId;
        console.log("projectId: " + projectId + ", boardId: " + boardId);

        this.queueListElm = null;

        this.state = {
            queueListMaxHeight: "auto"
        };
    }

    didClickCreateQueueButton = () => {
        OverlayController.showOverlay({
            component: <QueueDialog boardId={this.props.boardData.board.id} projectId={this.props.projectData.project.id} />
        });
    };

    onSortClick = () => {
        let queueIds = this.props.boardData.board.queues.map(queue => queue.id);
        this.props.beginReorder(queueIds);
    };

    onSaveSortClick = () => {
        let boardId = this.props.boardData.board.id;
        let queueIds = this.props.reorderItems;

        OverlayController.showActivityIndicator();
        this.props.updateQueuesOrder(boardId, queueIds)
            .then(() => {
                OverlayController.hideActivityIndicator();
                this.props.resetReorder();

            })
            .catch(error => {
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
                this.props.resetReorder()
            });
    };

    onCancelSortClick = () => {
        this.props.resetReorder()
    };

    componentDidMount() {
        this.setQueueItemListMaxHeightIfNeeded();
        window.addEventListener("resize", this.onWindowResizeHandler, false);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.onWindowResizeHandler, false);
    }

    componentDidUpdate() {
        this.setQueueItemListMaxHeightIfNeeded();
    }

    onWindowResizeHandler = () => {
        this.setQueueItemListMaxHeightIfNeeded();
    };

    setQueueItemListMaxHeightIfNeeded() {
        if (!this.queueListElm) {
            return;
        }

        let offsetParent = this.queueListElm;
        let offsetTop = 0;
        while (offsetParent) {
            offsetTop += offsetParent.offsetTop;
            offsetParent = offsetParent.offsetParent;
        }
        let documentHeight = document.documentElement.clientHeight;
        let queueListMaxHeight = (documentHeight - offsetTop - 10) + "px"; // -10 for queueList negative margin bottom
        if (this.state.queueListMaxHeight !== queueListMaxHeight) {
            this.setState({queueListMaxHeight: queueListMaxHeight});
        }
    }

    renderAdminButtons() {
        if (this.props.boardData.board.aclRole !== "admin") {
            return null;
        }
        return [
            <RaisedButton key="createQueue" className="createQueueButton" label="Create Queue" primary={true} onTouchTap={this.didClickCreateQueueButton}/>,
            this.renderSortQueuesButton()
        ]
    }

    renderSortQueuesButton() {
        if (this.props.boardData.board.queues.length <= 1) {
            return null;
        }
        if (!this.props.reordering) {
            return <RaisedButton key="sortQueues" className="sortQueuesButton" primary={true} onTouchTap={this.onSortClick}><i className="fa fa-sort fa-rotate-90"/></RaisedButton>;
        } else {
            return [
                <RaisedButton key="sortCancel" className="sortQueuesButton" primary={true} onTouchTap={this.onCancelSortClick}><i className="fa fa-times"/></RaisedButton>,
                <RaisedButton key="sortSave" className="sortQueuesButton" primary={true} onTouchTap={this.onSaveSortClick}><i className="fa fa-check"/></RaisedButton>
            ];
        }
    }

    renderQueueSortOverlay(queueId) {
        if (!this.props.reordering) {
            return null;
        }
        return (
            <div className="queueSortOverlay" data-reorder-item={queueId} onMouseDown={this.props.onMouseDown}>
                <div className="queueSortOverlayIconWrapper">
                    <i className="fa fa-sort fa-rotate-90 fa-5x"/>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.boardData.loading || this.props.projectData.loading) {
            return (
                <CircularProgress className="activityIndicator"/>
            )
        } else if (this.props.boardData.error || this.props.projectData.error) {
            return <pre>{GraphQLStackTrace(this.props.boardData.error || this.props.projectData.error)}</pre>;
        }

        let queues = this.props.boardData.board.queues;
        if (this.props.reordering) {
            queues = _.sortBy(queues, queue => this.props.indexOfItem(queue.id))
        }

        return (
            <div className="board">
                <div className="toolbar">
                    <h2 className="board-title">{this.props.boardData.board.name}</h2>
                    {this.renderAdminButtons()}
                </div>
                <ul className="queueList" ref={(elm) => this.queueListElm = elm} style={{maxHeight: this.state.queueListMaxHeight}}>
                    {queues.map(queue => {
                        let style = {};
                        let className = 'queueListItem';
                        if (this.props.draggedItem === queue.id) {
                            style = {transform: `translate(${this.props.translateX}px, 0px)`, zIndex: 10};
                            className += ' mdc-elevation--z10';
                        }
                        return (
                            <li className={className} key={queue.id} style={style}>
                                <Queue queue={queue} project={this.props.projectData.project}/>
                                {this.renderQueueSortOverlay(queue.id)}
                            </li>
                        );
                    })}
                    <li className="queueSpacer"/>
                </ul>
            </div>
        )
    }
});



// WEBPACK FOOTER //
// ./src/components/board/Board.js